import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetService } from 'src/app/Services/get.service';
import { PostService } from 'src/app/Services/post.service';
import { environment } from 'src/environments/environment';
import { contentLists } from '../contentForms';
import { SaveChangesComponent } from '../modals/save-changes/save-changes.component';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit, OnDestroy {

  contentTypeData: any;
  type: string;
  id: string;
  viewClicked: boolean;
  public mainForm: FormGroup;
  lang: string = 'en';
  fieldsCtrls = {};
  record;
  getRecordLink: string;
 detailSubscription = new Subscription();
  recordData: any;
  imageUrl;
  imageSrc = new Map();
  imageSizeError = new Map();


  hidearbic:boolean=false;
  constructor(
    private get: GetService,
    private route: ActivatedRoute,
    private post: PostService,
    private spinner: NgxSpinnerService,
    private dialog:MatDialog,private router:Router,
  ) {
    this.type = route.snapshot.paramMap.get('type');
    this.id = route.snapshot.paramMap.get('id');
    this.contentTypeData = contentLists[this.type];
    this.getRecordLink = contentLists[this.type].getRecordLink;



    this.createForm(this.contentTypeData.add_form.english);


    if(this.contentTypeData.hasCommon){
      this.createForm(this.contentTypeData.add_form.common);
    }
    if(this.contentTypeData.hasHidden){
      this.createForm(this.contentTypeData.add_form.hidden);
    }
    if(this.contentTypeData.hasArabic){
      this.createForm(this.contentTypeData.add_form.arabic);
    }


    this.mainForm = new FormGroup(this.fieldsCtrls);

  ;
    this.imageUrl = environment.imgUrl;
    setTimeout(() => {
      this.spinner.hide();
    }, 800);
  }
  createForm(fields) {
    for (let f of fields) {
      // if (f.type != 'checkbox') {
        this.fieldsCtrls[f.name] = new FormControl(
          f.value || '',
          Validators.required
        );
        if (f.type == 'file') {
          this.imageSrc[f.name] = f.value;
           this.imageSizeError[f.name] = false;
        }
      // } else {
      //   let opts = {};
      //   for (let opt of f.options) {

      //     opts[f.name] = new FormControl(opt.value);
      //   }
      //   this.fieldsCtrls[f.name] = new FormGroup(opts);
      // }
    }
  }

  ngOnInit(): void {
    this.spinner.show();

    this.getRecordData();

  }



  getRecordData() {
    this.detailSubscription = this.get.get(this.getRecordLink + this.id).subscribe((res) => {
      this.recordData = res.response.data;

      this.mainForm.patchValue(this.recordData);
      this.renderingSectionImages();

      if (this.type == 'ogtm') {
        // this.category_id=this.route.snapshot.paramMap.get('id');
        this.contentTypeData.backLink+=this.mainForm.get('category_id').value;
        this.contentTypeData.routerList+=this.mainForm.get('category_id').value;
        // listUrl += this.route.snapshot.paramMap.get('id');this.mainForm
      }
    });

  }

  renderingSectionImages() {
    // this.fillFormData();
    for (let fieldName in this.imageSrc) {
      this.imageSrc[fieldName] =this.imageUrl+ this.recordData[fieldName];

    }
    

  }


ngOnDestroy(): void {
    this.detailSubscription.unsubscribe();
}
}
